import { useEffect } from "react";
import "./AddEditProvisionModal.css";

const categories = [
  "Rice",
  "Atta",
  "Dal",
  "Oil",
  "Sugar",
  "Salt",
  "Spices",
  "Masala",
  "Tea",
  "Coffee",
  "Dry Fruits",
  "Biscuits",
  "Snacks",
  "Soft Drinks",
  "Dairy",
  "Frozen",
  "Cleaning",
  "Personal Care",
  "Baby Care",
  "Pet Food",
  "Others",
];

const units = [
  "Kg",
  "g",
  "L",
  "ml",
  "Piece",
  "Packet",
  "Bottle",
  "Box",
];

function AddEditProvisionModal({
  isOpen,
  onClose,
  formData,
  updateField,
  submitForm,
  loading,
  editingProduct,
}) {

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const success = await submitForm();

    if (success) {
      onClose();
    }
  };

  return (
    <div className="provision-form-overlay">

      <div className="provision-form-modal">

        <div className="modal-header">

          <h2>
            {editingProduct
              ? "Update Product"
              : "Add New Product"}
          </h2>

          <button
            className="close-btn"
            onClick={onClose}
          >
            ×
          </button>

        </div>

        <form onSubmit={handleSubmit}>

          <div className="form-grid">

            <div className="form-group">
              <label>Product Name</label>

              <input
                type="text"
                value={formData.productName}
                onChange={(e) =>
                  updateField(
                    "productName",
                    e.target.value
                  )
                }
                required
              />
            </div>

            <div className="form-group">
              <label>Brand</label>

              <input
                type="text"
                value={formData.brand}
                onChange={(e) =>
                  updateField(
                    "brand",
                    e.target.value
                  )
                }
              />
            </div>

            <div className="form-group">
              <label>Category</label>

              <select
                value={formData.category}
                onChange={(e) =>
                  updateField(
                    "category",
                    e.target.value
                  )
                }
              >
                {categories.map((item) => (
                  <option
                    key={item}
                    value={item}
                  >
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Unit</label>

              <select
                value={formData.unit}
                onChange={(e) =>
                  updateField(
                    "unit",
                    e.target.value
                  )
                }
              >
                {units.map((item) => (
                  <option
                    key={item}
                    value={item}
                  >
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Price</label>

              <input
                type="number"
                value={formData.price}
                onChange={(e) =>
                  updateField(
                    "price",
                    e.target.value
                  )
                }
                required
              />
            </div>

            <div className="form-group">
              <label>Offer Price</label>

              <input
                type="number"
                value={formData.offerPrice}
                onChange={(e) =>
                  updateField(
                    "offerPrice",
                    e.target.value
                  )
                }
              />
            </div>

            <div className="form-group">
              <label>Stock</label>

              <input
                type="number"
                value={formData.stock}
                onChange={(e) =>
                  updateField(
                    "stock",
                    e.target.value
                  )
                }
                required
              />
            </div>

            <div className="form-group">
              <label>Weight</label>

              <input
  type="number"
  min="0"
  step="0.01"
  value={formData.weight}
  onChange={(e) =>
    updateField("weight", e.target.value)
  }
/>
            </div>

            <div className="form-group full-width">
              <label>Description</label>

              <textarea
                rows="4"
                value={formData.description}
                onChange={(e) =>
                  updateField(
                    "description",
                    e.target.value
                  )
                }
              />
            </div>

            <div className="form-group full-width">
              <label>Product Image</label>

              <input
                type="file"
                accept="image/*"
                onChange={(e) =>
                  updateField(
                    "image",
                    e.target.files[0]
                  )
                }
              />
            </div>

            <div className="toggle-row">

              <label className="toggle-item">

                <input
                  type="checkbox"
                  checked={formData.isAvailable}
                  onChange={(e) =>
                    updateField(
                      "isAvailable",
                      e.target.checked
                    )
                  }
                />

                <span>Available</span>

              </label>

              <label className="toggle-item">

                <input
                  type="checkbox"
                  checked={formData.isFeatured}
                  onChange={(e) =>
                    updateField(
                      "isFeatured",
                      e.target.checked
                    )
                  }
                />

                <span>Featured</span>

              </label>

            </div>

          </div>

          <div className="modal-footer">

            <button
              type="button"
              className="cancel-btn"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="save-btn"
              disabled={loading}
            >
              {loading
                ? "Saving..."
                : editingProduct
                ? "Update Product"
                : "Add Product"}
            </button>

          </div>

        </form>

      </div>

    </div>
  );
}

export default AddEditProvisionModal;